module.exports = __webpack_public_path__ + "img/logosel.e797deb5.png";